import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class EmployeeDetail extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        employee: {},
    }

    show = (id, code, name) => {
        this.setState({
            data: [],
            visible: true,
            employee: {
                id: id,
                code: code,
                name: name,
            },
        }, () => {
            id && this.loadData(id);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = assignedUserId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.getEmployeeInfo,
            data: { assignedUserId },
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data.invInfoList
                });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '项目领域',
        dataIndex: 'investigationArea',
        key: 'investigationArea',
        width: 80,
        fixed: 'left',
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 120,
        fixed: 'left',
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 160,
        fixed: 'left',
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '项目阶段',
        dataIndex: 'stageNameShow',
        key: 'stageNameShow',
        width: 100,
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        width: 100,
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 120,
    }, {
        title: '科室',
        dataIndex: 'departmentName',
        key: 'departmentName',
        width: 100,
    }, {
        title: '区域',
        dataIndex: 'areaName',
        key: 'areaName',
        width: 80,
    }, {
        title: '城市',
        dataIndex: 'cityName',
        key: 'cityName',
        width: 80,
    }, {
        title: '中心启动时间',
        dataIndex: 'startTime',
        key: 'startTime',
        width: 100,
    }, {
        title: '累计FTE',
        dataIndex: 'totalMonthFte',
        key: 'totalMonthFte',
        width: 80,
    }, {
        title: '上月FTE',
        dataIndex: 'lastMonthFte',
        key: 'lastMonthFte',
        width: 80,
    }]

    getDataSource = () => {
        const { data } = this.state;

        const dataSource = (data || []).map(item => {
            const { totalMonthFte, lastMonthFte, investigationSite } = item;
            const { investigationSiteCode, investigationSiteName, departmentName, startTime, investigation, areaName, cityName } = investigationSite || {};
            const { investigationArea, investigationCode, investigationName, stageNameShow, lineOfBusinessString, secondLineNames } = investigation || {};
            
            return {
                totalMonthFte,
                lastMonthFte,
                investigationSiteCode,
                investigationSiteName,
                departmentName,
                startTime: startTime ? startTime.slice(0, 10) : '',
                investigationArea,
                investigationCode,
                investigationName,
                stageNameShow,
                lineOfBusinessString,
                secondLineNames,
                areaName,
                cityName
            };
        });
        return dataSource;
    }

    render() {
        const { visible, loading, employee } = this.state;
        const { code, name } = employee;
        return (
            <Modal
                title={'项目档案'}
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                zIndex={1001}
                width={1200}
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button key="back" type="primary" size="large" onClick={this.hide}>关闭</Button>}
            >
                {/* <div style={{ textAlign: 'center', fontSize: '16px' }}>项目档案</div> */}
                <div style={{ marginTop: 20, marginBottom: 14, paddingBottom: 14, borderBottom: '1px solid #d1d1d1' }}>
                    <span>工号：{code || ''}</span>
                    <span style={{ marginLeft: 20 }}>姓名：{name || ''}</span>
                </div>
                <TableC
                    loading={loading}
                    scrollY={500}
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    className="employeeDetail"
                />
            </Modal>
        );
    }
}

export default EmployeeDetail;



// WEBPACK FOOTER //
// ./src/components/user/require/components/EmployeeDetail.js